import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Termos from "../pages/termos/page";
import Privacidade from "../pages/privacidade/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/termos",
    element: <Termos />,
  },
  {
    path: "/privacidade",
    element: <Privacidade />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
